import { TS_OfferEvent } from "../TravelSeller/Models/TS_OfferEvent";
import { BookingItemInterface } from "./BookingItemInterface";

export class OfferEvent extends TS_OfferEvent implements BookingItemInterface {}
